/**
 * @generated SignedSource<<83e176285f068b8bada4cc4476702c9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamUpdatesAsideViewQuery$variables = {
  activeProjectsTql: string;
  cloudId?: string | null;
  completedProjectsTql: string;
  pausedProjectsTql: string;
  pendingProjectsTql: string;
  relatedGoalsTql: string;
  sidebarLimit: number;
  teamId: string;
  workspaceUUID: string;
};
export type TeamUpdatesAsideViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamSidebarColumn">;
};
export type TeamUpdatesAsideViewQuery = {
  response: TeamUpdatesAsideViewQuery$data;
  variables: TeamUpdatesAsideViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "activeProjectsTql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "completedProjectsTql"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pausedProjectsTql"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pendingProjectsTql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedGoalsTql"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidebarLimit"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v9 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v10 = {
  "kind": "Variable",
  "name": "teamId",
  "variableName": "teamId"
},
v11 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUUID"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "sidebarLimit"
},
v14 = [
  "LATEST_UPDATE_DATE_DESC"
],
v15 = {
  "kind": "Literal",
  "name": "sort",
  "value": (v14/*: any*/)
},
v16 = {
  "kind": "ScalarField",
  "name": "count"
},
v17 = {
  "kind": "ScalarField",
  "name": "key"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v20 = {
  "kind": "ScalarField",
  "name": "private"
},
v21 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v22 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aaid"
    },
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "accountId"
        }
      ]
    },
    (v12/*: any*/)
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "label"
},
v24 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = [
  (v16/*: any*/),
  {
    "concreteType": "ProjectEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamUpdatesAsideViewQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "activeProjectsTql",
            "variableName": "activeProjectsTql"
          },
          (v9/*: any*/),
          {
            "kind": "Variable",
            "name": "completedProjectsTql",
            "variableName": "completedProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "pausedProjectsTql",
            "variableName": "pausedProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "pendingProjectsTql",
            "variableName": "pendingProjectsTql"
          },
          {
            "kind": "Variable",
            "name": "relatedGoalsTql",
            "variableName": "relatedGoalsTql"
          },
          {
            "kind": "Variable",
            "name": "sidebarLimit",
            "variableName": "sidebarLimit"
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TeamSidebarColumn"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamUpdatesAsideViewQuery",
    "selections": [
      {
        "args": [
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "teamByTeamId",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "teamId"
          },
          (v12/*: any*/)
        ]
      },
      {
        "alias": "activeProjectsTql",
        "args": [
          (v13/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "activeProjectsTql"
          },
          (v15/*: any*/),
          (v11/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          {
            "concreteType": "ProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "concreteType": "ProjectState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "CompletionProjectState",
                        "kind": "LinkedField",
                        "name": "atCompletionState",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "pendingProjectsTql",
        "args": [
          (v13/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "pendingProjectsTql"
          },
          (v15/*: any*/),
          (v11/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": (v26/*: any*/)
      },
      {
        "alias": "pausedProjectsTql",
        "args": [
          (v13/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "pausedProjectsTql"
          },
          (v15/*: any*/),
          (v11/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": (v26/*: any*/)
      },
      {
        "alias": "completedProjectsTql",
        "args": [
          (v13/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "completedProjectsTql"
          },
          (v15/*: any*/),
          (v11/*: any*/)
        ],
        "concreteType": "ProjectConnection",
        "kind": "LinkedField",
        "name": "projectTql",
        "plural": false,
        "selections": (v26/*: any*/)
      },
      {
        "alias": "relatedGoalsTql",
        "args": [
          (v13/*: any*/),
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "relatedGoalsTql"
          },
          {
            "kind": "Literal",
            "name": "sorts",
            "value": (v14/*: any*/)
          },
          (v11/*: any*/)
        ],
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          {
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v17/*: any*/),
                  (v19/*: any*/),
                  {
                    "concreteType": "GoalIcon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "appearance"
                      }
                    ]
                  },
                  (v18/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f6d29fe51ed652ed6e34447d05f3bdf7",
    "id": null,
    "metadata": {},
    "name": "TeamUpdatesAsideViewQuery",
    "operationKind": "query",
    "text": "query TeamUpdatesAsideViewQuery(\n  $teamId: String!\n  $workspaceUUID: UUID!\n  $activeProjectsTql: String!\n  $pendingProjectsTql: String!\n  $pausedProjectsTql: String!\n  $completedProjectsTql: String!\n  $relatedGoalsTql: String!\n  $sidebarLimit: Int!\n  $cloudId: String\n) {\n  ...TeamSidebarColumn_1FniF7\n}\n\nfragment ActiveTeamProjectsSection_2lZLtl on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  activeProjectsTql: projectTql(q: $activeProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection_1O1zBL\n  }\n}\n\nfragment CompletedTeamProjectsSection_INMK3 on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  completedProjectsTql: projectTql(q: $completedProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalRowWithOwner on Goal {\n  key\n  ...GoalName\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment GoalWithOwnerSidebarSection on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalRowWithOwner\n    }\n  }\n}\n\nfragment PausedTeamProjectsSection_36NY8Z on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  pausedProjectsTql: projectTql(q: $pausedProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment PendingTeamProjectsSection_18ayXQ on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  pendingProjectsTql: projectTql(q: $pendingProjectsTql, workspaceUuid: $workspaceUUID, sort: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...ProjectWithOwnerSidebarSection\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectRowWithOwner_1O1zBL on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ProjectRowWithOwner_4yoa7g on Project {\n  key\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_4yoa7g\n    }\n  }\n}\n\nfragment ProjectWithOwnerSidebarSection_1O1zBL on ProjectConnection {\n  count\n  edges {\n    node {\n      id\n      ...ProjectRowWithOwner_1O1zBL\n    }\n  }\n}\n\nfragment RelatedTeamGoalsSection_2a5m5U on Query {\n  teamByTeamId(teamId: $teamId, cloudId: $cloudId) {\n    teamId\n    id\n  }\n  relatedGoalsTql: goalTql(q: $relatedGoalsTql, workspaceUuid: $workspaceUUID, sorts: [LATEST_UPDATE_DATE_DESC], first: $sidebarLimit) {\n    ...GoalWithOwnerSidebarSection\n  }\n}\n\nfragment TeamSidebarColumn_1FniF7 on Query {\n  ...ActiveTeamProjectsSection_2lZLtl\n  ...PendingTeamProjectsSection_18ayXQ\n  ...PausedTeamProjectsSection_36NY8Z\n  ...CompletedTeamProjectsSection_INMK3\n  ...RelatedTeamGoalsSection_2a5m5U\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b8c4c201257a192c4c4ca9865ee1edc";

export default node;
